/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React layouts
import DefaultNavbarLayout from "layouts/defaultNavbar";
import Footer from "layouts/footer";

// Images
import bgImage from "assets/images/Interior.jpg";

// Data
import products from "data/products";
import MKButton from "components/MKButton";

function Product({ productId }) {
  const navigate = useNavigate();
  const id = productId;

  const productData = products.find(
    (item) => item.id.toLowerCase() === (id ? id.toLowerCase() : "")
  );

  useEffect(() => {
    if (!productData) {
      navigate("/", { replace: true });
    }
  }, [productData, navigate]);

  if (!productData) return null;

  return (
    <>
      <DefaultNavbarLayout />
      <MKBox bgColor="white">
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage: ({
              functions: { linearGradient, rgba },
              palette: { gradients },
            }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.8),
                rgba(gradients.dark.state, 0.8)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
              rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <MKBox id="products" component="section" py={{ xs: 6, sm: 12 }} textAlign="center">
            <Container>
              <Grid container item xs={12} justifyContent="center" mx="auto">
                <Grid container justifyContent="center" py={3}>
                  <Grid item xs={12} md={7} mx={{ xs: "auto", sm: 6, md: 1 }}>
                    <MKBox
                      justifyContent="space-between"
                      alignItems="center"
                      mb={3}
                    >
                      <MKTypography variant="h3">
                        {productData.name}
                      </MKTypography>
                    </MKBox>
                    <MKTypography
                      variant="body1"
                      fontWeight="light"
                      color="text"
                    >
                      {productData.description} <br />
                    </MKTypography>
                    <MKBox my={2}>
                      <img
                        src={productData ? productData.image : ""}
                        alt={
                          productData
                            ? productData.name
                            : "Imagen no disponible"
                        }
                        style={{ width: "100%", borderRadius: "8px" }}
                      />
                    </MKBox>
                  </Grid>
                </Grid>
              </Grid>

              {productData &&
                productData.section.map((section, index) => {
                  const isLast = index === productData.section.length - 1;
                  return (
                    <Grid key={index}>
                      <Grid
                        container
                        item
                        xs={12}
                        justifyContent="center"
                        mx="auto"
                      >
                        <Grid container justifyContent="center" py={3}>
                          <Grid item xs={12} md={7} mx={{ xs: "auto", sm: 6, md: 1 }}>
                            <MKBox
                              justifyContent="space-between"
                              alignItems="center"
                              mb={3}
                            >
                              <MKTypography variant="h3" color="info">
                                {section.title}
                              </MKTypography>
                            </MKBox>
                            <MKTypography
                              variant="body1"
                              fontWeight="light"
                              color="text"
                            >
                              {section.description}
                            </MKTypography>
                          </Grid>
                          <Grid item mx={{ xs: "auto", sm: 6, md: 1}}>
                            <Grid container justifyContent="center" spacing={3} py={6}>
                              {section.caracteristics.map((caracteristic, idx) => (
                                <Grid key={idx} item xs={12} md={6} lg={3}>
                                  <MKBox mb={1}>
                                    <MKTypography variant="h5">
                                      {caracteristic.title}
                                    </MKTypography>
                                    <MKTypography variant="body2" color="text">
                                      {caracteristic.description}
                                    </MKTypography>
                                  </MKBox>
                                </Grid>
                              ))}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      {isLast && (
                        <Grid item xs={12} md={7} mx={{ xs: "auto", sm: 6, md: 1 }}>
                          <MKBox
                            justifyContent="space-between"
                            alignItems="center"
                            mb={3}
                          >
                            <MKTypography variant="h3" color="info">
                              ¿Queres saber más?
                            </MKTypography>
                          </MKBox>
                          <MKTypography
                            variant="body1"
                            fontWeight="light"
                            color="text"
                          >
                            Descargá la ficha técnica del vehículo para conocer más detalles.
                          </MKTypography>
                          <MKBox mt={3}>
                            <MKButton
                              color="info"
                              onClick={() => {
                                const pdfName = productData.id
                                  .toLowerCase()
                                  .replace(/\s+/g, "")
                                  .replace(/[^a-z0-9]/g, "");
                                window.open(`/assets/ficha_tecnica/ficha_${pdfName}.pdf`, "_blank");
                              }}
                            >
                              FICHA TÉCNICA
                            </MKButton>
                          </MKBox>
                        </Grid>
                      )}
                    </Grid>
                  )
                })}
            </Container>
          </MKBox>
        </Card>
        <Footer />
      </MKBox>
    </>
  );
}

export default Product;
